import { shouldShowNewContent } from '../../forms/MTPLPersonalInfoForm/formHelpers';

export const fieldsName = {
    vehicleBrand: 'vehicle-brand',
    vehicleConstructionYear: 'vehicle-constructionYear',
    vehicleModel: 'vehicle-model',
    vehicleVin: 'vehicle-vin',
    vehiclePlateNumber: 'vehicle-plateNumber',
    primaryInsuredPartySurname: 'primaryInsuredParty-surname',
    primaryInsuredPartyGivenName: 'primaryInsuredParty-givenName',
    primaryInsuredPartyMiddleName: 'primaryInsuredParty-middleName',
    primaryInsuredPartyBirthDate: 'primaryInsuredParty-birthDate',
    primaryInsuredPartyIpn: 'primaryInsuredParty-ipn',
    vehicleOwnerPartyType: 'vehicle-ownerPartyType',
    primaryInsuredPartyTranslitSurname: 'primaryInsuredParty-translitSurname',
    primaryInsuredPartyTranslitGivenName: 'primaryInsuredParty-translitGivenName',
    primaryInsuredPartyRegistrationDocumentNumber: 'primaryInsuredParty-registrationDocument-number',
    primaryInsuredPartyResident: 'primaryInsuredParty-resident',
    primaryInsuredPartyResidentCountry: 'primaryInsuredParty-residentCountry',
    primaryInsuredPartyLivingAddressTranslitUnstructured: 'primaryInsuredParty-livingAddress-translitUnstructured',
    primaryInsuredPartyEmail: 'primaryInsuredParty-email',
    primaryInsuredPartyMobileNumber: 'primaryInsuredParty-mobileNumber',
    ...(shouldShowNewContent() ? {
        engineType: 'vehicle-engineType',
        vehicleEngineCapacity: 'vehicle-engineCapacity',
        vehicleBatteryCapacity: 'vehicle-batteryCapacity',
        vehicleTotalWeight: 'vehicle-totalWeight',
        vehicleOwnWeight: 'vehicle-ownWeight',
        vehicleNumberSeating: 'vehicle-numberSeating',
    } : {}),
    ...(!shouldShowNewContent() ? {
        agreementPlace: 'agreementPlace',
    } : {}),
}